export const RECENT_QA_TAGS = {
  RECENT_QA_TAG: "RecentQA",
};
